import * as React from 'react';

import { filterMap } from '@acceligentllc/shared/utils/array';

import TableButtonType from 'ab-enums/tableButtonType.enum';

import { Button } from '@acceligentllc/storybook';

import SubmitButton from 'af-components/SubmitButton';

import type { ButtonData } from '../../types';
import styles from '../styles.module.scss';

interface OwnProps {
	buttons: ButtonData[];
	exportAsZip?: boolean;
}

type Props = OwnProps;

const buttonHasPermission = (button: ButtonData) => button.hasPermission;

const Buttons: React.FC<Props> = (props) => {

	const { exportAsZip = false, buttons } = props;

	const renderButton = React.useCallback(({ type, onClick, label, icon, actionKey, disabled }: ButtonData) => {

		const key = `${type}#${label}`;

		switch (type) {
			case TableButtonType.LINK:
				return (
					<Button
						icon={icon}
						key={key}
						label={label}
						onClick={onClick}
						style="link"
					/>
				);
			case TableButtonType.EXPORT:
				return (
					<Button
						icon="ActionDownload"
						key={key}
						label={`Export as ${exportAsZip ? 'ZIP' : 'CSV'}`}
						onClick={onClick}
						style="link"
					/>
				);
			case TableButtonType.PRIMARY:
			default:
				return (
					<SubmitButton
						disabled={disabled}
						icon={icon}
						key={key}
						label={label}
						onClick={onClick}
						submitKey={actionKey}
						variant="primary"
					/>
				);
		}
	}, [exportAsZip]);

	return (
		<div className={styles['action-header__filters__buttons']}>
			{filterMap(buttons, buttonHasPermission, renderButton)}
		</div>
	);
};

export default React.memo(Buttons);
